<div nz-row [nzGutter]="g[0].gutter" [nzAlign]="opts.align || 'middle'">
  <div 
    nz-col 
    [nzXs]="g[0].xs" 
    [nzSm]="g[0].sm" 
    [nzMd]="g[0].md" 
    [nzLg]="g[0].lg" 
    [nzXl]="g[0].xl" 
    [nzXXl]="g[0].xxl"
    >
    
    <ng-content select="[col0]"></ng-content>

  </div>  
  <div 
    nz-col 
    [nzXs]="g[1].xs" 
    [nzSm]="g[1].sm" 
    [nzMd]="g[1].md" 
    [nzLg]="g[1].lg" 
    [nzXl]="g[1].xl" 
    [nzXXl]="g[1].xxl"
    >
    
    <ng-content select="[col1]"></ng-content>

  </div>
</div>
